export default __webpack_public_path__ + "static/media/List_Black.0812203d.webp";